import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiClientConfig } from '../../api-client-config';
import { PtEntity, UiDocumentType } from '@pt/pt-models';
import { RequestLog } from '@primatoo-ms-organization';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient) {
    this.endpoint = this.config.endPoint + '/api/org/dashboard/logs/detail/';
  }

  public static getDocumentType(entity:PtEntity): UiDocumentType {
    switch (entity) {
      case 'aiAssessment':
        return 'AI_ASSESSMENT';
      case 'appAssessment':
        return 'APP_ASSESSMENT';
      case 'covidAssessment':
        return 'COVID_ASSESSMENT';
      case 'globalMeasureCheck':
        return 'GLOBAL_MEASURE_CHECK';
      case 'treatmentsHolder':
        return 'TREATMENT_HOLDER';
      case 'projectCards':
        return 'TREATMENT_PROJECT';
      case 'treatmentsResponsible':
        return 'TREATMENT_RESPONSIBLE';
      case 'treatmentsSubResponsible':
        return 'TREATMENT_SUB_RESPONSIBLE';
      case 'dpia':
        return 'DPIA';
    }
  }
  public static getEntity(docType: UiDocumentType): PtEntity {
    switch (docType) {
      case 'AI_ASSESSMENT':
        return 'aiAssessment';
      case 'APP_ASSESSMENT':
        return 'appAssessment';
      case 'COVID_ASSESSMENT':
        return 'covidAssessment';
      case 'GLOBAL_MEASURE_CHECK':
        return 'globalMeasureCheck';
      case 'TREATMENT_HOLDER':
        return 'treatmentsHolder';
      case 'TREATMENT_PROJECT':
        return 'projectCards';
      case 'TREATMENT_RESPONSIBLE':
        return 'treatmentsResponsible';
      case 'TREATMENT_SUB_RESPONSIBLE':
        return 'treatmentsSubResponsible';
      case 'DPIA':
        return 'dpia';
    }
  }

  getLogs(docId: number, type: UiDocumentType, from: number, to: number, timezone: string = 'Europe/Rome'): Observable<RequestLog[]> {
    const url = this.endpoint + `?type=${type}&from=${from}&to=${to}&resourceId=${docId}&timezone=${timezone}`;
    return this.httpClient.get<{resources: RequestLog[]}>(url).pipe(map(r => r.resources));
  }
}
